import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { ContentTypeRender } from "nystem-components";

const StylePortal = ({ model, path }) => {
  const [element, setElement] = useState(null);

  useEffect(() => {
    setElement(document.getElementById(model.target));
  }, [model.target]);

  return element ? createPortal(<ContentTypeRender path={path} items={model.item} />, element) : null;
};

export default StylePortal;
